import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { State, getCurrentUser } from '../../../../../store';
import { HeaderNavigation } from '../header-navigation.types';

export const accountNavigationLoader: HeaderNavigation.Loader = () => {
  const store$ = inject<Store<State>>(Store);
  const user$ = store$.select(getCurrentUser);

  return user$.pipe(
    map((user) => {
      if (
        user?.OktaUsername__c?.length &&
        user?.Account?.Okta_Login_Enabled__c
      ) {
        const children: HeaderNavigation.Item[] = [
          {
            label: { prefixIcon: 'manage_accounts', text: 'Account' },
            pathname: '/manage/account',
            ariaLabel: 'Navigate to manage account',
          },
          {
            label: { prefixIcon: 'logout', text: 'Sign Out' },
            pathname: '/logout',
            ariaLabel: 'Sign out',
          },
        ];
        return {
          label: {
            prefixIcon: 'person',
          },
          ariaLabel: 'Account menu dropdown',
          children,
        };
      }

      return {
        pathname: '/logout',
        label: 'Sign out',
        ariaLabel: 'Sign out',
      };
    }),
  );
};
